import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { updateConsent, acceptAll } from '../store/cookieConsentSlice';
import { useTranslation } from 'react-i18next';

interface CookieBannerProps {
  flowerImagePath: string;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ flowerImagePath }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { consent } = useSelector((state: RootState) => state.cookieConsent);

  const isBot = typeof navigator !== 'undefined' &&
    /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|crawler|spider|bot|claude|claudebot|gptbot|chatgpt|openai/i.test(navigator.userAgent);
  if (consent.hasInteracted || isBot) {
    return null;
  }

  const handleNecessaryOnly = () => {
    dispatch(updateConsent({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
    }));
  };

  const handleAcceptAll = () => {
    dispatch(acceptAll());
  };

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4">
      <div className="bg-white w-full max-w-3xl relative rounded-lg overflow-hidden">
        <div className="absolute -right-4 -bottom-4 h-48 w-48 md:h-64 md:w-64 opacity-[0.12] pointer-events-none">
          <img src={flowerImagePath} alt="" className="h-full w-full object-contain" />
        </div>
        <div className="relative z-20 p-6 md:p-10">
          <h2 className="text-xl md:text-2xl font-bold text-[#49ABDB] text-center">
            {t('cookieConsent.title')}
          </h2>
          <p className="text-sm md:text-base text-gray-600 mt-4">
            {t('cookieConsent.message')}
          </p>
          <p className="text-sm md:text-base text-gray-600 mt-2">
            {t('cookieConsent.necessaryRequired')}
          </p>
          <div className="flex flex-col sm:flex-row justify-end gap-2 mt-6">
            <button
              onClick={handleNecessaryOnly}
              className="w-full sm:w-auto px-4 py-2 text-[#47ABDB] border border-[#47ABDB] hover:bg-[#f0f8ff] transition-colors text-sm md:text-base"
            >
              {t('cookieConsent.acceptNecessary')}
            </button>
            <button
              onClick={handleAcceptAll}
              className="w-full sm:w-auto px-4 py-2 bg-[#47ABDB] text-white border border-transparent hover:bg-[#0056b3] transition-colors text-sm md:text-base"
            >
              {t('cookieConsent.accept')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
